import React from 'react';
import type { TablePreviewStats } from './tablePreviewStats';

/**
 * Screen-reader-only metadata for PDF table export (excluded from html2canvas).
 */
const TableExportPdfMetadata: React.FC<{
    previewStats: TablePreviewStats;
    deepLinkUrl?: string;
    'data-test-id'?: string;
}> = ({ previewStats, deepLinkUrl, 'data-test-id': dataTestId }) => (
    <div data-export-exclude data-export-table-deeplink className="sr-only" data-test-id={dataTestId}>
        <span data-export-table-preview-stats={JSON.stringify(previewStats)} aria-hidden />
        {deepLinkUrl ? (
            <span data-export-table-deeplink-url={deepLinkUrl} aria-hidden>
                Open in AskAsper
            </span>
        ) : null}
    </div>
);

export default TableExportPdfMetadata;
